export default [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Top/TopIndex'),
    meta: { requiresAuth: true }
  },
  {
    path: '/User',
    name: 'UserIndex',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Admin/M0001User/M0001AdminUserIndex'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ScanRecord',
    name: 'ScanRecordIndex',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Admin/M0301ScanRecord/M0301ScanRecordIndex'),
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/'
  }
]
